// @flow
import alt from '../alt';

import ConfigActions from '../actions/ConfigActions';
import NotificationActions from '../actions/NotificationActions';
import ConfigSource from '../sources/ConfigSource';

import _ from 'underscore';
import t from '../trans';
import rootStore from "./index";

/**
 * Konfiguratsiooni haldamise store
 *
 * Olekudiagramm: PROCESSING -> OK / FAIL
 *
 */
class ConfigStore {
    constructor() {
        this.state = {
            config: {},
            state: "OK"
        };
        this.bindActions(ConfigActions);
        this.exportAsync(ConfigSource);
    }

    /**
     * Toote laadimise käivitamine
     */
    onFetchConfig() {
        this.setState({state: "PROCESSING"});
        let p = this.getInstance().fetchConfig();
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function () {});
    }

    /**
     * Toote laadimine ebaõnnestus
     */
    onFetchConfigFailed(error) {
        this.processError(error);
    }

    processError(error) {
        let message = t('Server error');
        if (error.response) {
            if (error.response.data && error.response.data.error && error.response.data.error.message) {
                message = error.response.data.error.message;
            }
            else {
                switch (error.response.status) {
                    case 401:
                    case 403:
                        // Authentication required
                        console.log("ConfigStore.processError(): STATUS 401/403: invalidating session");
                        rootStore.sessionStore.invalidate();
                        message = t("Invalid password");
                        break;
                    case 503:
                        message = t("Service unavailable");
                        break;
                    default:
                        message = t("Server error");
                }
            }
            switch (error.response.status) {
                case 401:
                case 403:
                    // Authentication required
                    console.log("ConfigStore.processError(): STATUS 401/403: invalidating session");
                    rootStore.sessionStore.invalidate();
                    this.setState({state: "FAIL"});
                    break;
                default:
                    this.setState({state: "FAIL"});
            }
        } else {
            this.setState({state: "FAIL"});
        }
        NotificationActions.error.defer(message);
    }

    onFetchConfigDone(response) {
        try {
            if (!_.has(response.data, 'configurationResult')) throw t("Server error");
            if (response.data.configurationResult == null) this.setState({config: {}, state: "OK"});
            else this.setState({config: response.data.configurationResult, state: "OK"});
        } catch (e) {
            if (!_.isString(e)) {
                console.log(e.toString());
                NotificationActions.error.defer(t("Server error"));
            }
            else NotificationActions.error.defer(e);
            this.setState({state: "FAIL"});
        }
    }

    onSaveConfig() {
        this.setState({state: "PROCESSING"});
        let p = this.getInstance().saveConfig();
        // We need to catch the exception - this is already processed but if we do not catch this we receive warning in console
        p.catch(function () {});
    }

    onSaveConfigFailed(error) {
        this.processError(error);
    }

    onSaveConfigDone() {
        NotificationActions.success.defer(t('Configuration saved'));
        this.setState({state: "OK"});
    }

    /**
     * Parameetri muutmine
     */
    onChangeValue(info) {
        if (!this.validateValue(info)) return;

        let newConfig = _.clone(this.state.config);
        let isChanged = false;

        switch (info.field) {
            default:
                break;
        }
        newConfig[info.field] = info.value;
        if (newConfig[info.field] !== this.state.config[info.field]) isChanged = true;

        if (!isChanged) return;

        switch (info.field) {
            default:
                break;
        }

        this.setState({
            config: newConfig
        });
    }

    validateValue(info) {
        switch (info.field) {
            default:
                break;
        }
        return true;
    }

}

export default alt.createStore(ConfigStore, 'ConfigStore');
